@if (mode === 'cta') {
  <div
    class="px-3 pt-3 pb-2 m-0"
    [appAlertStyle]="severity"
    [ngClass]="{ 'cursor-pointer': count > 0 }"
    (click)="showDetails()">
    <div class="flex gap-2 pb-2 font-bold align-items-center">
      <i [class]="icon"></i> {{ label }}
    </div>
    <div class="py-3 text-7xl">
      {{ count }}
    </div>
    @if (text) {
      <div class="flex align-items-center gap-3">
        <i class="text-5xl" [class]="getIconBySeverity()"></i>
        <div [innerHTML]="text"></div>
      </div>
    }
    <div class="text-right py-2" *ngIf="count > 0">
      <a>Details <i class="fas fa-arrow-right"></i></a>
    </div>
  </div>
} @else if (count > 0) {
  <div [class]="styleClass">
    <div class="m-3">
      <div
        class="border-1 surface-border border-round-xl p-4 text-color-secondary">
        <header class="flex align-items-baseline gap-3">
          <div>
            <h3 class="mt-0 mb-1 font-semibold text-3xl">
              {{ label }}
            </h3>
            @if (text) {
              <div [innerHTML]="text"></div>
            }
          </div>
          <div
            class="surface-border border-1 border-round-xl ml-auto w-3rem h-3rem flex flex-shrink-0 justify-content-center align-items-center text-base">
            <i [class]="icon"></i>
          </div>
        </header>
        <div class="text-7xl flex align-items-center gap-3 font-italic">
          <i class="fas fa-hashtag text-5xl"></i> <strong>{{ count }}</strong>
        </div>
      </div>
    </div>
  </div>
}
